import {ValidationErrorKeys} from '@hconnect/common/consts'
import {removeMarkdownTags} from '@hconnect/common/utils'
import {type TFunction} from 'i18next'
import {object, string, date, array} from 'yup'

const DESCRIPTION_MAX_LENGTH = 5000

export const getMachineSentryActionValidationSchema = ({t}: {t: TFunction}) =>
  object().shape({
    // intentionally no max length for title in machine sentry action
    title: string().trim().required(t(ValidationErrorKeys.REQUIRED)),
    description: richTextFieldValidatationSchema({t, max: DESCRIPTION_MAX_LENGTH}),
    plantUpmId: string().required(t(ValidationErrorKeys.REQUIRED)),
    functionalLocation: string().required(t(ValidationErrorKeys.REQUIRED)),
    processStage: string().notRequired(),
    equipment: object().notRequired(),
    mainEquipment: object().notRequired(),
    status: string().required(t(ValidationErrorKeys.REQUIRED)),
    priority: string().optional(),
    dueDate: date().required(t(ValidationErrorKeys.REQUIRED)),
    assignees: array().of(object()).notRequired()
  })

const richTextFieldValidatationSchema = ({t, max}: {t: TFunction; max: number}) =>
  string()
    .trim()
    .required(t(ValidationErrorKeys.REQUIRED))
    .test('max-length-without-markdown', t(ValidationErrorKeys.MAX_LENGTH, {max}), (value) => {
      if (!value) return false
      const plainText = removeMarkdownTags(value)
      return plainText.length <= max
    })
